import React from 'react';

const Card = ({title, content, button, onClick}) => {
    return (
        <div className="col-md-4">
            <div className="card text-center" styleName="width: 18rem;">
                <div className="card-body">
                    <h5 className="card-title">{title}</h5>
                    <p className="card-text">{content}</p>
                    <a href="#" className="btn btn-primary" onClick={onClick}>{button}</a>
                </div>
            </div>
            <br />
        </div>
    );
}

export default Card;